import Button from "components/base/Button";
import { useNavigate } from "react-router-dom";

function PackingListButton({ shipmentId, onBeforeGenerate }) {
  const navigate = useNavigate();

  return (
    <Button
      onClick={() => {
        if (!onBeforeGenerate || onBeforeGenerate()) {
          navigate(`/shipment/doc/packing-list/${shipmentId}/preview`);
        }
      }}
    >
      Packing List
    </Button>
  );
}

export default PackingListButton;
